import ChevronDownIcon from '@discover-ui/icons/chevron-down.svg';

export default function DropdownIcon() {
  return <ChevronDownIcon className="size-4 lg:ml-auto lg:text-gray-300" />;
}
